import { gql } from '@apollo/client';
import { request } from 'network/queue';
import { CommonLocalizableString } from 'network/common/cmsFragment';
import { mapLocalizable } from 'models/cms/common/utils';

const boothNameByIdQuery = gql`
  query boothNameById(
    $boothId: ID!,
    $locales: [Locale!]!
  ) {
    node(id: $boothId) {
      ...CommonBooth
    }
  }
  fragment CommonBooth on Booth {
    name {
      ...CommonLocalizableString
    }
  }
  ${CommonLocalizableString}
`;

const fetchBoothNameByIdRequest = async (boothId: string, locales: string[]) => {
  const boothName = await request({ query: boothNameByIdQuery, variables: { boothId, locales } });
  return {
    id: boothId,
    ...mapLocalizable(boothName).node,
  };
};

export default fetchBoothNameByIdRequest;
